<template>
  <div class="page-access page-content">
    <PageHeader title="账户信息" />
    
    <div class="page-scroll-box">
      <!-- 查看 -->
      <template v-if="!visibleEdit">
        <div class="header_ctrl">
          <el-button type="primary" @click="handleEdit" size="mini">修改</el-button>
          <span class="tips_text">(该模块信息与结算相关，请根据合同签约信息填写)</span>
        </div>
        
        <el-divider content-position="left">基础信息</el-divider>
        <div class="row">
          <div class="label">公司主体</div>
          <div class="cont">{{ form.media_mainbody || '-' }}</div>
        </div>
        <div class="row">
          <div class="label">统一社会信用代码</div>
          <div class="cont">{{ form.media_qua_num || '-' }}</div>
        </div>
        <div class="row">
          <div class="label">营业执照</div>
          <div class="cont">
            <a :href="form.business_license" target="_blank"><img v-if="form.business_license" :src="form.business_license" class="avatar"></a>
          </div>
        </div>
        <div class="row">
          <div class="label">软件著作权</div>
          <div class="cont">
            <a :href="form.copyright" target="_blank"><img v-if="form.copyright" :src="form.copyright" class="avatar"></a>
          </div>
          <div v-if="!form.copyright" style="color:#A9A9A9;font-size:13px;">请上传软件著作权，未上传可能会影响消耗</div>
        </div>
  
        <el-divider content-position="left">银行信息</el-divider>
        <div class="row">
          <div class="label">开户行</div>
          <div class="cont">{{ form.bank || '-' }}</div>
        </div>
        <div class="row">
          <div class="label">银行账号</div>
          <div class="cont">{{ form.bank_account || '-' }}</div>
        </div>
  
        <el-divider content-position="left">联系人</el-divider>
        <div class="row">
          <div class="label">联系人</div>
          <div class="cont">{{ form.contacts || '-' }}</div>
        </div>
        <div class="row">
          <div class="label">联系邮箱</div>
          <div class="cont">{{ form.contact_email || '-' }}</div>
        </div>
      </template>
      
      <!-- 编辑 -->
      <template v-else>
        <el-form label-width="140px" :rules="rules" ref="detail" :model="form" label-position="left">
          <el-divider content-position="left">基础信息</el-divider>
          <el-form-item label="公司主体" prop="media_mainbody">
            <el-input v-model="form.media_mainbody" size="small" class="input" placeholder="请输入公司主体" :disabled="type === 2"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="media_qua_num">
            <el-input v-model="form.media_qua_num" size="small" class="input" placeholder="请输入统一社会信用代码" :disabled="type === 2"></el-input>
          </el-form-item>
          <el-form-item label="营业执照" prop="business_license" style="margin-bottom: 50px;">
            <!-- <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="handleUploadSuccess"
              :disabled="type === 2"
            > -->
            <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :before-upload="beforeUpload"
              :on-success="handleUploadSuccess"
              :disabled="((form.business_license !== '') && (flagBusinessLicense === false) ? true : false)"
            >
              <div v-if="form.business_license" class="image-container">
                <img :src="form.business_license" class="avatar">
                <i 
                  v-if="!((form.business_license !== '') && (flagBusinessLicense === false))"
                  class="el-icon-close delete-icon" 
                  @click.stop="removeImage('business_license')"
                ></i>
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="软件著作权" prop="copyright" style="margin-bottom: 50px;">
            <!-- <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :before-upload="beforeUploadSoftwareCopyright"
              :on-success="handleUploadSuccessSoftwareCopyright"
              :disabled="type === 2"
            > -->
            <el-upload
              class="avatar-uploader"
              :action="uploadUrl"
              :headers="headers"
              :show-file-list="false"
              :before-upload="beforeUploadSoftwareCopyright"
              :on-success="handleUploadSuccessSoftwareCopyright"
              :disabled="((form.copyright !== '') && (flagCopyright === false) ? true : false)"
            >
              <div v-if="form.copyright" class="image-container">
                <img :src="form.copyright" class="avatar">
                <i 
                  v-if="!((form.copyright !== '') && (flagCopyright === false))"
                  class="el-icon-close delete-icon" 
                  @click.stop="removeImage('copyright')"
                ></i>
              </div>
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
            <div v-if="!form.copyright" style="color:#A9A9A9;font-size:13px;">请上传软件著作权，未上传可能会影响消耗</div>
          </el-form-item>
  
          <el-divider content-position="left">银行信息</el-divider>
          <el-form-item label="开户行" prop="bank">
            <el-input v-model="form.bank" size="small" class="input" placeholder="请输入开户行"></el-input>
          </el-form-item>
          <el-form-item label="银行账号" prop="bank_account" style="margin-bottom: 50px;">
            <el-input v-model="form.bank_account" size="small" class="input" placeholder="请输入银行账号"></el-input>
          </el-form-item>
          
          <el-divider content-position="left">联系人</el-divider>
          <el-form-item label="联系人" prop="contacts">
            <el-input v-model="form.contacts" size="small" class="input" placeholder="请输入联系人"></el-input>
          </el-form-item>
          <el-form-item label="联系邮箱" prop="contact_email">
            <el-input v-model="form.contact_email" size="small" class="input" placeholder="请输入联系邮箱"></el-input>
          </el-form-item>
        </el-form>
        <div style="margin-top: 30px;">
          <el-button type="primary" @click="handleSave">保存</el-button>
          <el-button @click="handleCancel">取消</el-button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import { TOKEN } from '@/common/storageKeys';
import { getInfo, infoAdd, infoUpdate } from '@/apis/account.js';
import { getUserInfo } from '@/apis/login';
import Vue from "vue";

export default {
  name: 'account-info',
  data () {
    return {
      uploadUrl: `${process.env.VUE_APP_API_HOST}/upload/file`,
      headers: { token: Vue.ls.get(TOKEN) },
      
      type: 1, // 1添加, 2编辑
      visibleEdit: true,
      rules: {
        media_mainbody: [{ required: true, message: '请输入公司主体' }],
        media_qua_num: [{ required: true, message: '请输入统一社会信用代码' }],
        // business_license: [{ required: true, message: '请上传营业执照' }],
        bank: [{ required: true, message: '请输入开户行' }],
        bank_account: [{ required: true, message: '请输入银行账号' }],
        contacts: [{ required: true, message: '请输入联系人' }],
        contact_email: [{ required: true, message: '请输入联系邮箱' }],
      },
      form: {
        media_mainbody: '',
        media_qua_num: '',
        business_license: '',
        bank: '',
        bank_account: '',
        contacts: '',
        contact_email: '',
        copyright: ''
      },
      
      wrapLeft: '',
      userInfo: {},
      flagBusinessLicense: false,
      flagCopyright: false,
    }
  },
  components: {
    PageHeader
  },
  mounted() {
    this.init();
  },
  
  methods: {
    removeImage(type) {
      if (type === 'business_license') {
        this.form.business_license = '';
        this.flagBusinessLicense = false; // 重置标志，允许重新上传
      } else if (type === 'copyright') {
        this.form.copyright = '';
        this.flagCopyright = false; 
      }
    },
    init() {
      this.getAccountInfo();
      this.handlePrompt();
    },
    
    handlePrompt() {
      this.userInfo = this.$ls.get('userInfo');
      if ([1].includes(this.userInfo.account_status)) return;
      
      // this.wrapLeft = document.querySelector('#wrap_left');
      // let dom = document.createElement('div');
      // dom.id = 'wrapLeftMaskBg';
      // dom.className = 'left_mask';
      // dom.addEventListener('click', () => {
      //   this.$message.info('请完善账户信息，完善后可进行其他操作。');
      // });
      // this.wrapLeft.append(dom);
    },
    
    async getAccountInfo() {
      const res = await getInfo();
      if (res && res.code === 200) {
        if (res.data && res.data.id) {
          this.type = 2;
          this.visibleEdit = false;
          this.form = {
            ...res.data
          }
        }
      }
    },
    
    handleEdit() {
      this.visibleEdit = true;
    },
  
    handleCancel() {
      this.$refs['detail'].resetFields();
      this.visibleEdit = false;
    },
    
    async handleSave() {
      this.$refs['detail'].validate(async (valid) => {
        if (!valid) return;
        
        let params = {
          ...this.form
        }
        let res = null;
        if (this.type === 1) {
          res = await infoAdd(params);
        } else {
          res = await infoUpdate(params);
        }
        if (res && res.code === 200) {
          this.$message.success('操作成功');

          // 更新登录用户基本信息
          const data = await getUserInfo();
          this.userInfo = data.data;
          this.$ls.set('userInfo', this.userInfo);

          this.getAccountInfo();
          this.handleCancel();
          
          // try {
          //   this.wrapLeft.querySelector('#wrapLeftMaskBg').remove();
          // } catch (err) {console.log(err);}
        }
      });
    },
  
    handleUploadSuccess(res) {
      if (res && res.code === 200) {
        this.form.business_license = res.data.imageUrl;
        this.flagBusinessLicense = true
      }
    },
    handleUploadSuccessSoftwareCopyright(res) {
      if (res && res.code === 200) {
        this.form.copyright = res.data.imageUrl;
        this.flagCopyright = true
      }
    },
    
    beforeUpload(file) {
      const isCan = ['image/jpg', 'image/jpeg', 'image/png'].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;
    
      if (!isCan) {
        this.$message.error('上传图片格式只支持jpg/jpeg/png格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isCan && isLt2M;
    },
    beforeUploadSoftwareCopyright(file) {
      const isCan = ['image/jpg','image/jpeg','image/png'].includes(file.type);
      const isLt2M = file.size / 1024 / 1024 < 2;
    
      if (!isCan) {
        this.$message.error('上传图片格式只支持jpg/png格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!');
      }
      return isCan && isLt2M;
    }
  }
}
</script>

<style lang="scss" scoped>
// 修改删除图标样式
.image-container {
  position: relative;
  display: inline-block;
  
  .delete-icon {
    position: absolute;
    top: -10px;  
    right: -10px; 
    cursor: pointer;
    background: #fff;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    border-radius: 50%;
    font-size: 16px;
    color: #A9A9A9;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
    transition: all 0.3s;
  }
}
@import "~@/assets/css/page.scss";
.header_ctrl{
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  .tips_text{
    margin-left: 10px;
    font-size: 14px;
    color: #409EFF;
  }
}
.page-scroll-box{
  .input{width: 400px;}
}
</style>
<style lang="scss">
.left_mask{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}
.avatar-uploader {
  ::v-deep .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: visible; // 允许图标超出容器
    
    &:hover {
      border-color: #409EFF;
    }
  }
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px dashed #d9d9d9;
}
.avatar {
  max-width: 178px;
  max-height: 178px;
  display: block;
}

.row{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 10px 0;
  .label{
    width: 130px;
    font-size: 14px;
    color: #000;
  }
  .cont{
    font-size: 14px;
    color: #787878;
  }
}
</style>
